




























import Vue from "vue";
import { proxyModel } from "@/common/utils/proxyModel";
import { RawStatus } from "../forms/DeliveryRawStatusForm";
export default Vue.extend({
  props: {
    value: {
      type: Object as () => RawStatus
    },
    validation: {
      type: Object
    }
  },
  computed: {
    ...proxyModel("name", "status"),
    nameError() {
      return (this as any).validation.name.$error ? "Name is required" : "";
    },
    statusError() {
      return (this as any).validation.status.$error ? "Status is required" : "";
    }
  },
  methods: {
    deleteRow() {
      this.$emit("deleteRow");
    }
  }
});
